export default __webpack_public_path__ + "static/media/logo.7ad470b4.png";